<template>
  <Modal v-model="addSubsidyRulesModal" :title="addSubsidyRulesTitle" width="650" class-name="addSubsidyRulesStyle"
    :transfer="false" :mask-closable="false" @on-visible-change="addSubsidyRulesChange">
    <Form ref="addSubsidyRulesForm" :model="addSubsidyRulesForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
      <Row>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" class="reset_name_style">
          <Form-item :label="$t('key1001437')" prop="name">
            <Input v-model.trim="addSubsidyRulesForm.name" clearable :placeholder="$t('key1002165')" style="width: 400px;"></Input>
          </Form-item>
          <span class="tips_txt">{{ $t('key1005150') }}</span>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1005145')" prop="subsidyObject">
            <Select v-model="addSubsidyRulesForm.subsidyObject" style="width: 400px;">
              <Option v-for="(item,idx) in subsidyObjectList" :key="idx" :value="item.value">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1005146')" prop="subsidyType">
            <Select v-model="addSubsidyRulesForm.subsidyType" style="width: 400px;">
              <Option v-for="(item,idx) in subsidyTypeList" :key="idx" :value="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <div class="subsidyConditions_content">
            <h3 class="title red-dot">{{ $t('key1005151') }}</h3>
            <div class="subsidyConditions_box" v-for="(item,index) in subsidyConditionsList" :key="index">
              <!--条件-->
              <div class="condition_title">{{ $t('key1005149') + (index + 1) + '：' }}</div>
              <!--条件选项-->
              <div class="flex align-items-center" style="width: 220px;">
                <div class="flex align-items-center" v-if="item.conditionType === 'shippingEfficiency'">
                  <TimePicker format="HH:mm" :placeholder="$t('key1005147')" v-model="item.time" style="width: 94px"></TimePicker>
                  <div style="text-align: center; width: 20px;">{{ $t('key1004140') }}</div>
                </div>
                <Select v-model="item.conditionType" transfer class="mr12" style="felx:1" @on-change="subsidyConditionsChange">
                  <Option v-for="(talg,idx) in item.conditionTypeList" :key="idx" :value="talg.value">{{ talg.name }}</Option>
                </Select>
              </div>
              <!--选择加减等-->
              <Select v-model="item.typeValue" transfer style="width: 60px;" class="mr12" placeholder="">
                <Option v-for="(talg,idx) in item.typeValueList" :key="idx" :value="talg.value">{{ talg.name }}</Option>
              </Select>
              <!--条件选项值-->
              <div style="margin-right: 8px;">
                <!--提单内货品数量-->
                <Input v-if="item.conditionType === 'goodsQuantity'" v-model.trim="item.value" style="width:200px;"
                  clearable :placeholder="$t('key1000324')"></Input>
                <!--发货方式-->
                <Select v-if="item.conditionType === 'shippingMethod'" v-model="item.value" transfer style="width:200px;" :placeholder="$t('key1000101')">
                  <Option v-for="(ele,ids) in deliveryMethodList" :key="ids" :value="ele.value">{{ ele.name }}</Option>
                </Select>
                <!--订单发货率-->
                <div class="flex align-items-center" v-if="item.conditionType === 'shippingEfficiency'">
                  <Input v-model="item.value" style="width:200px;" :placeholder="$t('key1000324')" type="number">
                    <span v-if="item.conditionType === 'shippingEfficiency'" slot="append">%</span>
                  </Input>
                </div>
                <!--供应商商户号-->
                <Input v-if="item.conditionType === 'supplierMerchantId'" type="textarea" :placeholder="$t('key1005148')"
                  style="width:200px;" :autosize="{ minRows: 3, maxRows: 3}" v-model.trim="item.value">
                </Input>
              </div>
              <!--删除图标-->
              <Icon type="ios-trash" color="rgb(225 31 18)" size="24" class="cursor deleteIconStyle"
                v-if="subsidyConditionsList.length>1" @click="deleteConditionBtn(item, index)"/>
            </div>
          </div>
          <span class="cursor themeColor" style="margin-left: 47px; font-size: 12px;" v-if="subsidyConditionsList.length<4"
            @click="addConditionBtn">+ {{ $t('key1005152') }}</span>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <div class="subsidyConditions_content mt20">
            <h3 class="title red-dot">{{ $t('key1005153') }}</h3>
            <div class="subsidyAmount_box">
              <RadioGroup v-model="addSubsidyRulesForm.subsidyAmountType">
                <Radio v-for="(item,index) in subsidyAmountTypeList" :key="index" :label="item.value">{{ item.name }}</Radio>
              </RadioGroup>
              <h3 class="redColor mt10" v-if="['addChild', 'editChild'].includes(subsidyRulesLevel)">{{ $t('key1005154') }}</h3>
              <div v-if="addSubsidyRulesType === 'child'" class="redColor mt10">{{ $t('key1005154') }}</div>
              <div class="flex align-items-center mt20" v-if="addSubsidyRulesForm.subsidyAmountType === 1">
                <span class="line_txt">{{ $t('key1005155') }}</span>
                <InputNumber :max="9999999999" :min="0" v-model="addSubsidyRulesForm.subsidyAmountPerOrder" style="width: 180px"></InputNumber>
                <span class="ml5">{{ currencyState }}</span>
              </div>
              <div class="flex flex-direction" v-if="addSubsidyRulesForm.subsidyAmountType === 2">
                <div class="flex align-items-center mt20">
                  <span class="line_txt">{{ $t('key1005156') }}</span>
                  <InputNumber :max="9999999999" :min="0" v-model="addSubsidyRulesForm.subsidyAmountWithinOneKG" style="width: 180px"></InputNumber>
                  <span class="ml5">{{ currencyState }}</span>
                </div>
                <div class="flex align-items-center mt20">
                  <span class="line_txt">{{ $t('key1005157') }}</span>
                  <InputNumber :max="9999999999" :min="0" v-model="addSubsidyRulesForm.subsidyAmountPerKGOverOne" style="width: 180px"></InputNumber>
                  <span class="ml5">{{ currencyState }}</span>
                </div>
                <div class="flex align-items-center mt20">
                  <span class="line_txt">{{ $t('key1005158') }}</span>
                  <InputNumber :max="9999999999" :min="0" v-model="addSubsidyRulesForm.subsidyAmountCeilingPerOrder" style="width: 180px"></InputNumber>
                  <span class="ml5">{{ currencyState }}</span>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="addSubsidyRulesModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="addSubsidyRulesBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {amountHandel} from "@/utils/common";

export default {
  name: "addSubsidyRulesModal",
  mixins: [Mixin],
  props: {
    originalConditionTypeData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    subsidyObjectList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    subsidyTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    typeValueList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    deliveryMethodList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    subsidyAmountTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      addSubsidyRulesModal: false,
      addSubsidyRulesTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005124'),
      addSubsidyRulesForm: {
        name: '', // 规则名称
        subsidyObject: 'supplier',  // 补贴对象
        subsidyType: 1, // 补贴类型
        subsidyAmountType: 1, // 补贴金额
        subsidyAmountPerOrder: null, // 单个提单补贴
        subsidyAmountWithinOneKG: null,  //  0-1公斤补贴
        subsidyAmountPerKGOverOne: null,  //  续重每公斤补贴
        subsidyAmountCeilingPerOrder: null,  //  单个提单补贴上限
      },
      ruleValidate: {
        name: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001334'), trigger: 'blur'}
        ],
        subsidyObject: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005136'), trigger: 'change'}
        ],
        subsidyType: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005137'), trigger: 'change'}
        ],
      },
      subsidyConditionsList: [
        {
          conditionType: null,
          conditionTypeList: [],
          typeValue: null,
          value: null,
          time: null
        }
      ],
      conditionTypeList: [],
      subsidyRulesLevel: '',
      addSubsidyRulesType: 'add',
      autoRuleId: null,
      verificationTalg: false,
    };
  },
  methods: {
    // 初始化数据
    initAddSubsidyRulesData(level, type, autoRuleId) {
      let v = this;
      let obj = {
        addParent: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005124'),
        addChild: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005138'),
        editParent: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005139'),
        editChild: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005140')
      };
      v.subsidyRulesLevel = level;
      v.addSubsidyRulesType = type;
      v.handleConditionTypeData();
      v.addSubsidyRulesTitle = obj[level];
      v.autoRuleId = autoRuleId;
      if (type !== 'add') {
        v.subsidyConditionsList = [];
        v.getSubsidyRulesDetails(autoRuleId);
      } else {
        v.addSubsidyRulesModal = true;
      }
    },
    // 获取补贴规则详情信息
    getSubsidyRulesDetails(autoRuleId) {
      let v = this;
      v.axios.get(api.get_ymsSubsidyAutoRule + autoRuleId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000514')}).then(res => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data) {
            v.addSubsidyRulesForm.name = data.selectedRule.name;
            if (data.ruleItems && data.ruleItems.length > 0) {
              if (data.ruleItems) {
                data.ruleItems.map((ele) => {
                  v.originalConditionTypeData.map((talg) => {
                    if (ele.ruleCode === talg.code) {
                      if (ele.ruleItemParams) {
                        ele.ruleItemParams.map((k) => {
                          if (k.name === talg.value) {
                            let val = JSON.parse(k.value);
                            val.name = k.name;
                            v.handleSubsidyConditionsData(val);
                          }
                        });
                      }
                    }
                  });
                });
              }
            }
            if (data.ruleActions && data.ruleActions.length > 0) {
              let values = data.ruleActions.filter((item) => {
                return item.type === 'ymsSubsidyAutoRule';
              })[0].value;
              let obj = JSON.parse(values);
              v.addSubsidyRulesForm.subsidyAmountType = obj.subsidyAmountType;
              let keyList = [
                'subsidyAmountPerOrder',
                'subsidyAmountWithinOneKG',
                'subsidyAmountPerKGOverOne',
                'subsidyAmountCeilingPerOrder'
              ];
              keyList.map((key) => {
                v.addSubsidyRulesForm[key] = obj[key] ? Number(obj[key]) : null;
              });
            }
          }
          v.addSubsidyRulesModal = true;
        }
      });
    },
    // 处理补贴条件数据
    handleSubsidyConditionsData(data) {
      if (data) {
        if (['subsidyObject', 'subsidyType'].includes(data.name)) {
          this.addSubsidyRulesForm[data.name] = data.obj.value;
        } else {
          this.subsidyConditionsList.push({
            conditionType: data.name,
            conditionTypeList: [],
            typeValue: data.symbol,
            value: data.name === 'shippingEfficiency' ? amountHandel(data.obj.value * 100) : data.obj.value,
            time: data.obj.shipedTime || null
          });
        }
        this.handleConditionTypeData();
      }
    },
    // 保存按钮
    addSubsidyRulesBtn() {
      let v = this;
      let query = {
        autoRuleActions: [], // 规则动作
        autoRuleItems: [], // 规则项
        businessId: null,
        name: v.addSubsidyRulesForm.name,
        status: 0,
        autoRuleId: v.autoRuleId
      };
      let method = '';
      let url = '';
      let text = '';
      if (v.addSubsidyRulesType === 'add') {
        url = api.post_ymsSubsidyAutoRule;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488');
      } else {
        url = api.put_ymsSubsidyAutoRule;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000839');
      }
      v.$refs['addSubsidyRulesForm'].validate((valid) => {
        if (valid) {
          v.verificationRequired();
          if (v.verificationTalg) {
            let values = {};
            if (v.addSubsidyRulesForm.subsidyAmountType === 1) {
              values = {
                subsidyAmountType: v.addSubsidyRulesForm.subsidyAmountType,
                subsidyAmountPerOrder: amountHandel(v.addSubsidyRulesForm.subsidyAmountPerOrder)
              };
            } else if (v.addSubsidyRulesForm.subsidyAmountType === 2) {
              values = {
                subsidyAmountType: v.addSubsidyRulesForm.subsidyAmountType,
                subsidyAmountWithinOneKG: amountHandel(v.addSubsidyRulesForm.subsidyAmountWithinOneKG),
                subsidyAmountPerKGOverOne: amountHandel(v.addSubsidyRulesForm.subsidyAmountPerKGOverOne),
                subsidyAmountCeilingPerOrder: amountHandel(v.addSubsidyRulesForm.subsidyAmountCeilingPerOrder),
              };
            } else {
              values = {
                subsidyAmountType: v.addSubsidyRulesForm.subsidyAmountType
              };
            }
            query.autoRuleActions = [{
              type: 'ymsSubsidyAutoRule',
              value: JSON.stringify(values)
            }];
            v.subsidyConditionsList.map((item) => {
              let val = {};
              let ruleCode = item.conditionTypeList.filter((ele) => {
                return ele.value === item.conditionType;
              })[0].code;
              if (item.conditionType === 'shippingEfficiency') {
                let value = Number(item.value) / 100;
                val = {
                  symbol: item.typeValue,
                  obj: {
                    value: value.toFixed(2),
                    shipedTime: item.time
                  }
                };
              }
              if (item.conditionType === 'supplierMerchantId') {
                let value = (v.sepCommasFn(item.value)).join(',');
                val = {
                  symbol: item.typeValue,
                  obj: {
                    value: value
                  }
                };
              }
              if (!['shippingEfficiency', 'supplierMerchantId'].includes(item.conditionType)) {
                val = {
                  symbol: item.typeValue,
                  obj: {
                    value: item.value
                  }
                };
              }
              query.autoRuleItems.push({
                ruleCode: ruleCode,
                autoRuleParams: [
                  {
                    name: item.conditionType,
                    type: 0,
                    value: JSON.stringify(val)
                  }
                ]
              });
            });
            let list = [
              {
                ruleCode: 'CORE-YPOSR-002',
                autoRuleParams: [{
                  name: 'subsidyObject',
                  type: 0,
                  value: JSON.stringify({
                    symbol: v.typeValueList.filter((talg) => {
                      return talg.value === 3;
                    })[0].value,
                    obj: {
                      value: v.addSubsidyRulesForm.subsidyObject
                    }
                  })
                }],
              },
              {
                ruleCode: 'CORE-YPOSR-006',
                autoRuleParams: [{
                  name: 'subsidyType',
                  type: 0,
                  value: JSON.stringify({
                    symbol: v.typeValueList.filter((talg) => {
                      return talg.value === 3;
                    })[0].value,
                    obj: {
                      value: v.addSubsidyRulesForm.subsidyType
                    }
                  })
                }],
              },
            ];
            query.autoRuleItems = [...query.autoRuleItems, ...list];
            if (['addChild', 'editChild'].includes(v.subsidyRulesLevel)) {
              query.parentAutoRuleId = v.autoRuleId;
            }
            v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.addSubsidyRulesModal = false;
                v.$Message.success(text);
                v.$emit('updateData', true);
              }
            });
          }
        }
      });
    },
    // 校验补贴金额、条件是否必填
    verificationRequired() {
      let v = this;
      v.verificationTalg = true;
      //补贴条件
      for (let i = 0; i < v.subsidyConditionsList.length; i++) {
        let keyList = ['conditionType', 'value', 'typeValue'];
        let item = v.subsidyConditionsList[i];
        if (item.conditionType) {
          if (item.conditionType === 'shippingEfficiency') {
            keyList = [...keyList, 'time'];
          }
          for (let j = 0; j < keyList.length; j++) {
            let key = keyList[j];
            // 判断不能为空，可以是0
            if (!item[key] && String(item[key]) !== '0') {
              v.verificationTalg = false;
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005141'));
              return false;
            }
          }
          if (item.conditionType === 'goodsQuantity') {
            let reg = v.$regular.minPositiveInteger;
            if (!reg.test(Number(item.value))) {
              v.verificationTalg = false;
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005142'));
              return false;
            }
          }
          if (item.conditionType === 'shippingEfficiency') {
            let reg = v.$regular.decimal;
            if (!reg.test(Number(item.value))) {
              v.verificationTalg = false;
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005143'));
              return false;
            }
          }

        } else {
          v.verificationTalg = false;
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005141'));
          return false;
        }
      }
      // 补贴金额
      if ([1, 2].includes(v.addSubsidyRulesForm.subsidyAmountType)) {
        let keyList = ['subsidyAmountPerOrder'];
        if (v.addSubsidyRulesForm.subsidyAmountType === 2) {
          keyList = ['subsidyAmountWithinOneKG', 'subsidyAmountPerKGOverOne', 'subsidyAmountCeilingPerOrder'];
        }
        for (let i = 0; i < keyList.length; i++) {
          let key = keyList[i];
          if (!v.addSubsidyRulesForm[key]) {
            v.verificationTalg = false;
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005144'));
            return false;
          }
        }
      }
    },
    // 切换补贴条件
    subsidyConditionsChange(value) {
      let v = this;
      v.handleConditionTypeData(value);
    },
    // 处理条件的数据
    handleConditionTypeData(value) {
      let v = this;
      let selectValus = v.subsidyConditionsList.filter((item) => {
        return item.conditionType;
      });
      let list = JSON.parse(JSON.stringify(v.originalConditionTypeData));
      let newList = list.filter((item) => {
        return !['subsidyType', 'subsidyObject'].includes(item.value);
      });
      v.subsidyConditionsList.map((item) => {
        item.typeValueList = JSON.parse(JSON.stringify(v.typeValueList));
        if (selectValus.length > 0) {
          let values = selectValus.map((item) => {
            return item.conditionType;
          });
          let arr2 = newList.filter((ele) => {
            return !values.includes(ele.value);
          });
          if (item.conditionType) {
            let arr1 = newList.filter((ele) => {
              return ele.value === item.conditionType;
            });
            if (item.conditionType === 'shippingMethod' || item.conditionType === 'supplierMerchantId') {
              item.typeValue = 3;
              item.typeValueList = v.typeValueList.filter((talg) => {
                return talg.value === 3;
              });
            }
            item['conditionTypeList'] = [...arr1, ...arr2];
          } else {
            item['conditionTypeList'] = [...arr2];
          }
        } else {
          item['conditionTypeList'] = newList;
        }
      });
    },
    // 添加条件
    addConditionBtn() {
      let v = this;
      let obj = {
        conditionType: null,
        conditionTypeList: [],
        typeValue: null,
        value: null,
        time: null
      };
      v.subsidyConditionsList.push(obj);
      v.handleConditionTypeData();
    },
    // 移除补贴条件
    deleteConditionBtn(item, index) {
      let v = this;
      v.subsidyConditionsList.splice(index, 1);
      v.handleConditionTypeData();
    },
    // 监听弹窗
    addSubsidyRulesChange(value) {
      if (!value) {
        this.$refs['addSubsidyRulesForm'].resetFields();
        this.addSubsidyRulesTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005124');
        this.conditionTypeList = [];
        this.subsidyRulesLevel = '';
        this.addSubsidyRulesType = 'add';
        this.autoRuleId = null;
        this.verificationTalg = false;
        this.subsidyConditionsList = [
          {
            conditionType: null,
            conditionTypeList: [],
            typeValue: null,
            value: null,
            time: null
          }
        ];
        this.addSubsidyRulesForm.subsidyAmountPerOrder = null;
        this.addSubsidyRulesForm.subsidyAmountWithinOneKG = null;
        this.addSubsidyRulesForm.subsidyAmountPerKGOverOne = null;
        this.addSubsidyRulesForm.subsidyAmountCeilingPerOrder = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .addSubsidyRulesStyle {
  .reset_name_style {
    position: relative;

    .tips_txt {
      position: absolute;
      top: 36px;
      left: 90px;
      font-size: 12px;
    }

    .ivu-form-item-error-tip {
      left: 170px;
    }
  }

  .subsidyConditions_content {
    font-size: 12px;
    margin-bottom: 20px;

    .title {
      margin: 0 0 10px 30px;
    }

    .subsidyConditions_box {
      display: flex;
      align-items: flex-start;
      padding-left: 47px;
      margin-bottom: 20px;

      .condition_title {
        min-width: 43px;
        height: 30px;
        line-height: 30px;
      }

      .deleteIconStyle {
        position: relative;
        top: 4px;
      }
    }

    .subsidyAmount_box {
      padding-left: 47px;
      font-size: 12px;

      .line_txt {
        display: inline-block;
        min-width: 110px;
        text-align: right;
      }
    }
  }
}
</style>